export const PAYMENT_INVALID_STAUSES = ['REJECTED','CANCELED'];
export const PAYMENT_ACCEPTED_STAUSES = ['APPROVED'];
export const PAYMENT_PENDING_STAUSES = ['NEW','PENDING'];
export function getEventTaxForParticipant(){
    
}

export function hasOkPayments(participant){
    for (const payment of participant.payments) {
        if (!isPaymentCanceled(payment)) {
            return true;
        }
    }
    return false;
}

export function getTaxPayment(participant, includePending = false){
    for (const payment of participant.payments) {
        if (payment.payedEventTax && payment.payedEventTax.length > 0  && (isPaymentAccepted(payment) || (includePending && isPaymentPending(payment)))) {
            return payment;
        }
    }
}

export function getTaxLastPayment(participant){
    for (const payment of participant.payments) {
        if (payment.payedEventTax && payment.payedEventTax.length > 0) {
            return payment;
        }
    }
}

export function getServicePayment(participant, serviceId, includePending = false){
    const service = participant.services.selectedServices.find( s=> s.serviceId == serviceId);
      if(service && service.serviceReservationId){
        for(const payment of participant.payments){            
          if(payment.payedServiceReservation && (isPaymentAccepted(payment) || (includePending && isPaymentPending(payment)))){
            const servicePayment = payment.payedServiceReservation.find(payedService=> payedService.serviceReservation.id==service.serviceReservationId);
            if(servicePayment){
                return servicePayment;
            }
          }
        }
      }
}

export function getServiceLastPayment(participant, serviceId){
    const service = participant.services.selectedServices.find( s=> s.serviceId == serviceId);
      if(service && service.serviceReservationId){
        for(const payment of participant.payments){            
          if(payment.payedServiceReservation){
            const servicePayment = payment.payedServiceReservation.find(payedService=> payedService.serviceReservation.id==service.serviceReservationId);
            if(servicePayment){
                return payment;
            }
          }
        }
      }
}

export function getRoomPayment(participant, roomReserveId, includePending = false){
    for(const payment of participant.payments){
        if(payment.payedRoomReservation && (isPaymentAccepted(payment) || (includePending && isPaymentPending(payment)))){
        const roomPayment = payment.payedRoomReservation.find(payedRoom => payedRoom.roomReservation.id == roomReserveId);
        if(roomPayment) {
            return roomPayment;
        }
        }
    }
}

export function getRoomLastPayment(participant, roomReserveId){
    for(const payment of participant.payments){
        if(payment.payedRoomReservation){
        const roomPayment = payment.payedRoomReservation.find(payedRoom => payedRoom.roomReservation.id == roomReserveId);
        if(roomPayment) {
            return payment;
        }
        }
    }
}

export function isTaxPayed(participant, includePending = false) {
    return getTaxPayment(participant,includePending)!=undefined;
}

export function isServicePayed(participant, serviceId , includePending = false) {
    return getServicePayment(participant,serviceId, includePending)!=undefined;
}

export function isRoomPayed(participant, roomReserveId, includePending =false) {
    return getRoomPayment(participant,roomReserveId, includePending)!=undefined;
}

export function isPaymentCanceled(payment) {
    return payment && PAYMENT_INVALID_STAUSES.includes(payment.status);
}

export function isPaymentAccepted(payment) {
    return payment && PAYMENT_ACCEPTED_STAUSES.includes(payment.status);
}

export function isPaymentPending(payment) {
    return payment && PAYMENT_PENDING_STAUSES.includes(payment.status);
}

export function setServicePriceBasedOnPayment(participant, service){
    const servicePayment = getServicePayment(participant, service.id, true);
    if(servicePayment){
        service.price = servicePayment.ammount;
    }
    return service;
}

export function matchParticipantCondition(participant, condition){
    if(!condition){
        return true;
    }
    const func = new Function('participant', `return ${condition};`);
    const resultEval = func(participant);
    return resultEval
}
